import { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import Grid from '@mui/material/Grid'
import InCardStack from 'components/atoms/container/InCardStack'
import contentPaperEditIcon from 'assets/images/contentPaperEdit.svg'
import RowStack from 'components/atoms/container/RowStack'
import { patchRequest } from 'utils/api'
import { USER_CONNECTION_EVENTS_URL } from 'services/constants'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import ImportMeetingItem from 'components/molecules/myTeam/ImportMeetingItem'
import { DialogBodyContainer } from 'components/molecules/myTeam/ImportOneOnOneMolecules'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import { useTranslation, Trans } from 'react-i18next'
import { trackMeetingBotSet } from 'services/amplitudeMeetingTracking'

const AddNoteTakerBody = ({
  candidates,
  setLoading,
  onSuccess = () => {},
  onError = () => {},
  cancelBtnText = 'common.cancel',
  cancelBtnAction = () => {},
  progressBar = false,
  currentProgress,
  stepCount,
  showSkip = false
}) => {
  const { t } = useTranslation()
  const [noteTakerCandidates, setNoteTakerCandidates] = useState([])
  const [selected, setSelected] = useState([])
  const [openSkip, setOpenSkip] = useState(false)

  useEffect(() => {
    const newNoteTakerCandidates = candidates.map(x => {
      return {
        ...x,
        masterCalendarEventId: x.userConnectionEvent.masterCalendarEventId,
        attendee: x.attendee || {
          email: x.userConnectionEvent?.userConnection?.email
        }
      }
    })
    setNoteTakerCandidates(newNoteTakerCandidates)
    setSelected(newNoteTakerCandidates)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidates])

  const handleSave = async () => {
    setLoading(true)
    let isSaveError = false
    await Promise.all(
      selected.map(async event => {
        const request = {
          recordMeeting: true
        }
        if (!event.meetingUrl) {
          request.videoConference = true
        }
        const res = await patchRequest(
          `${USER_CONNECTION_EVENTS_URL}/${event.userConnectionEventId}`,
          request
        )
        if (res.status === 200) {
          trackMeetingBotSet(event, 'Meetings page')
        } else {
          isSaveError = true
        }
      })
    )

    if (isSaveError) {
      onError()
    } else {
      onSuccess()
    }
    setLoading(false)
  }

  const handleSkip = () => {
    if (showSkip) setOpenSkip(true)
    else cancelBtnAction()
  }

  const handleClose = confirmed => {
    if (confirmed) {
      cancelBtnAction()
    }
    setOpenSkip(false)
  }

  return (
    <>
      {noteTakerCandidates.length > 0 && (
        <>
          <DialogBodyContainer
            icon={contentPaperEditIcon}
            title={t('calendarEvents.addMonarksNoteTaker')}
            description={
              <Trans i18nKey='calendarEvents.selectMeetingsForSummaries' />
            }
            progressBar={progressBar}
            currentProgress={currentProgress}
            stepCount={stepCount}>
            <BoxWithBackground width='100%' sx={{ padding: 8 }}>
              <InCardStack
                spacing={4}
                width='100%'
                maxHeight={280}
                overflow='auto'>
                {noteTakerCandidates.map(x => (
                  <ImportMeetingItem
                    key={x.eventId}
                    candidate={x}
                    selected={selected}
                    setSelected={setSelected}
                  />
                ))}
              </InCardStack>
            </BoxWithBackground>
          </DialogBodyContainer>

          <Grid size={12} alignSelf='flex-end' height={44}>
            <RowStack spacing={5} justifyContent='center'>
              <Button color='muted' onClick={handleSkip}>
                {t(cancelBtnText)}
              </Button>
              <Button
                variant='contained'
                disabled={!selected.length}
                onClick={() => handleSave()}>
                {t('calendarEvents.addSelected', {
                  count: selected.length
                })}
              </Button>
            </RowStack>
          </Grid>

          <CommonDialog
            open={openSkip}
            onClose={handleClose}
            titleText={t('calendarEvents.skipNoteNaker')}
            notificationText={t('calendarEvents.addnoteTakerLater')}
            confirmText={t('calendarEvents.yesSkipNoteTaker')}
            cancelText={t('common.cancel')}
          />
        </>
      )}
    </>
  )
}

export default AddNoteTakerBody
